import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "JavaScript’s most popular dataviz library",
  "description": "Yesterday we talked about how data visualization helps you understand the world. Today I wanted to tell you about JavaScript's most popular data visualization library 👉 D3.",
  "date": "2019-02-26T08:00:00.000Z",
  "lastUpdated": "2019-02-26T08:00:00.000Z",
  "image": "./img/24R4Mll.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday we talked about how data visualization helps you understand the world. Today I wanted to tell you about JavaScript`}{`'`}{`s most popular data visualization library 👉 D3.`}</p>
    <p>{`D3 is amazing.`}</p>
    <p>{`D3 can do stuff like this`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.nytimes.com/interactive/2014/upshot/mapping-the-spread-of-drought-across-the-us.html"
      }}><img parentName="a" {...{
          "src": "/6fcf56d97a07939468c3095c41493cd5/tNfXLwD.gif",
          "alt": null
        }}></img></a></p>
    <p>{`And like this`}</p>
    <p><a parentName="p" {...{
        "href": "https://bl.ocks.org/kerryrodden/7090426"
      }}><img parentName="a" {...{
          "src": "/7bb3e1a8dd05321a996a3e6014ab4512/Djk8yKX.gif",
          "alt": null
        }}></img></a></p>
    <p>{`D3 can even do 3D globe effects like this 😱`}</p>
    <p><a parentName="p" {...{
        "href": "http://bl.ocks.org/dwtkns/4973620"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.466367713004495%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'210\\'%20viewBox=\\'0%200%20400%20210\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M186%2014c-15%202-29%208-43%2019l-9%205c0-2-1%200-4%205l-7%2012a94%2094%200%2000-7%2089l3%205-2%201c-2%201-2%201%200%201%202-1%203%200%207%205l11%2014c7%206%207%207%205%207-3%200-11%204-14%206-9%209%206%2017%2037%2020l13%203%202-1c-1-1%204-1%209%201l1-1c-1-1%200-1%203-1%2012%200%2031-2%2038-4%208-2%2011-3%205-3h-1l4-3%207-3%205-4-3%201c-7%204-5-1%203-6a95%2095%200%200042-65v-6l1-5v-2l-1-8a79%2079%200%2000-6-24c0-2-5-12-11-20l-3-6v-1l-8-6a94%2094%200%2000-77-25m17%2049l-1%202v3c-1%201-1%201-2-1l-2-2-1%203c-2%204-1%207%201%206h6c7%203%2013%202%2014-2s1-5-4-4-7%200-8-3c0-3-2-4-3-2m50%2030l-8%204-6%205c-6%203-5%203-5%204%201%201%202%200%205-1a789%20789%200%20016%200c0%202%201%201%207-4%203-3%206-5%207-4l1-1c-1-1-1-1%200%200h1v-3c1-3%200-2-8%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/08da0ac5b5c514b66d49d9e73c271f0a/ca0a1/24R4Mll.webp 223w", "/static/08da0ac5b5c514b66d49d9e73c271f0a/75680/24R4Mll.webp 445w", "/static/08da0ac5b5c514b66d49d9e73c271f0a/8d1ba/24R4Mll.webp 890w", "/static/08da0ac5b5c514b66d49d9e73c271f0a/af3f0/24R4Mll.webp 1280w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/08da0ac5b5c514b66d49d9e73c271f0a/e92b6/24R4Mll.png 223w", "/static/08da0ac5b5c514b66d49d9e73c271f0a/e66bf/24R4Mll.png 445w", "/static/08da0ac5b5c514b66d49d9e73c271f0a/4ef49/24R4Mll.png 890w", "/static/08da0ac5b5c514b66d49d9e73c271f0a/21b4d/24R4Mll.png 1280w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
        `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/08da0ac5b5c514b66d49d9e73c271f0a/4ef49/24R4Mll.png",
              "alt": "24R4Mll",
              "title": "24R4Mll",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
      `}</picture>{`
    `}</span></a></p>
    <p>{`No wonder D3 is so popular. Like 82,000 stars on GitHub popular.`}</p>
    <p>{`Used by The New York Times, The Guardian, and others for data journalism. Powering tools at Netflix, Uber, Gusto, 23andMe and other industry giants. D3 is everywhere.`}</p>
    <p>{`If you saw an interactive data visualization, chances are it was built with D3.`}</p>
    <p>{`2 reasons D3 is so popular 👇`}</p>
    <p>{`1) Data science is the fastest growing field in software engineering `}<a parentName="p" {...{
        "href": "https://www.infoworld.com/article/3259891/data-science/why-data-science-and-machine-learning-are-the-fastest-growing-jobs-in-the-us.html"
      }}>{`[`}{`1`}{`]`}</a></p>
    <p>{`2) D3 is the best way to build custom dataviz on the web. SVG, HTML, Canvas, even WebGL. You can do it all with D3.`}</p>
    <p>{`D3 comes with a rich ecosystem of functions for almost anything you can think of. From simple medians, to automatic axis generators, and force diagrams.`}</p>
    <p>{`Want to build a chart? You can; D3 might be too powerful.`}</p>
    <p>{`Want a map? D3 has `}{`'`}{`em.`}</p>
    <p>{`Want an interactive dashboard? D3.`}</p>
    <p>{`Want to wow users with a unique twist on your dataset? Yep, D3.`}</p>
    <p>{`Want users to dig into their own data? D3.`}</p>
    <p>{`D3 is where it`}{`'`}{`s at for custom interactive data visualization on the web. ✌️`}</p>
    <h2 {...{
      "id": "but-have-you-tried-learning-d3-before-oof"
    }}>{`But have you tried learning D3 before? oof`}</h2>
    <p>{`Here`}{`'`}{`s how it went when I first tried to learn D3.`}</p>
    <p><em parentName="p">{`"`}{`A-ha! I have an idea`}{`"`}</em></p>
    <p><img parentName="p" {...{
        "src": "/afa5c486409a97f7744bed34dbbb6042/media-dgKrQw280pFGsAa1ld-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`I took my idea and looked for a dataset. Some people have the dataset first. That`}{`'`}{`s probably smart.`}</p>
    <p>{`And then ...`}</p>
    <p><img parentName="p" {...{
        "src": "/d76b608d7ef70616b666a1affc8f6758/media-WxKe34zkYomreUH1XH-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`I had no idea how to start. I knew D3 was great. I knew it could do what I wanted. But WHAT DO I DO!?`}</p>
    <p>{`So I looked for an example ... and discovered this mess`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3e9eff79e2cd414ee224aabb6c0e54de/cf8e5/z7HIM2z.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "108.96860986547085%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'437\\'%20viewBox=\\'0%200%20400%20437\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2029v379c2%201%203%202%20181%202%20152%200%20179-1%20180-2%202-1%202-14%202-189l-1-190c-1-2-361-2-362%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/3e9eff79e2cd414ee224aabb6c0e54de/ca0a1/z7HIM2z.webp 223w", "/static/3e9eff79e2cd414ee224aabb6c0e54de/75680/z7HIM2z.webp 445w", "/static/3e9eff79e2cd414ee224aabb6c0e54de/8d1ba/z7HIM2z.webp 890w", "/static/3e9eff79e2cd414ee224aabb6c0e54de/3838e/z7HIM2z.webp 1335w", "/static/3e9eff79e2cd414ee224aabb6c0e54de/7e452/z7HIM2z.webp 1402w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/3e9eff79e2cd414ee224aabb6c0e54de/e92b6/z7HIM2z.png 223w", "/static/3e9eff79e2cd414ee224aabb6c0e54de/e66bf/z7HIM2z.png 445w", "/static/3e9eff79e2cd414ee224aabb6c0e54de/4ef49/z7HIM2z.png 890w", "/static/3e9eff79e2cd414ee224aabb6c0e54de/4e814/z7HIM2z.png 1335w", "/static/3e9eff79e2cd414ee224aabb6c0e54de/cf8e5/z7HIM2z.png 1402w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
        `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/3e9eff79e2cd414ee224aabb6c0e54de/4ef49/z7HIM2z.png",
              "alt": "z7HIM2z",
              "title": "z7HIM2z",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Ugh ... what is this code even doing? No matter, copy paste and hope for the best, right? As long as it works.`}</p>
    <p>{`And then you tweak and tinker and move stuff around until the project looks right. A working visualization great success!`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/9883f29c7216403768967aadf93bdf6e/fa60d/9echESi.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50.672645739910315%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'202\\'%20viewBox=\\'0%200%20400%20202\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M15%206c2%200%202%201%202%205s0%205-2%205v1c2%200%202%201%202%207s0%207-2%208v1c3%200%203%2015%200%2015v1c2%200%203%2014%201%2014v18c2%200%201%2014-1%2014v1c3%200%203%2015%200%2015v1c3%200%203%2015%200%2015v1c2%200%203%2014%201%2014v18c2%200%201%2014-1%2014v1c3%200%203%2015%200%2015v1a5158%205158%200%20003-88V5h-2c-2%200-2%200-1%201m67%2097v97h14V5H82v98m228%2029v68h14V63h-14v69M22%2078l-1%2061v61h14V77h-6l-7%201m212%2066v57h14V87h-14v57m-91%204v52h14V96h-14v52m76%201v51h14V100l-7-1h-7v50m76%204v47h13v-94h-13v47m-167%202v45h14v-90h-14v45m151-43v88h14v-88h-14M67%20170v30h14v-61H67v31m122-27l-1%2029v28h14v-58h-6l-7%201M52%20181v19h14v-38H52v19m273%200v19h14v-38h-14v19m-121%203v16h13v-32h-13v16m151%201v15h14v-31h-14v16m-258%200v15h14v-30H97v15m16%202v13h13v-26h-13v13m273%201v12h14v-25h-14v13m-137%200v12h14v-24h-14v12m-212%203v9h13v-18H37v9m303%200v9h14v-9h-14\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/9883f29c7216403768967aadf93bdf6e/ca0a1/9echESi.webp 223w", "/static/9883f29c7216403768967aadf93bdf6e/75680/9echESi.webp 445w", "/static/9883f29c7216403768967aadf93bdf6e/8d1ba/9echESi.webp 890w", "/static/9883f29c7216403768967aadf93bdf6e/3838e/9echESi.webp 1335w", "/static/9883f29c7216403768967aadf93bdf6e/e11e5/9echESi.webp 1780w", "/static/9883f29c7216403768967aadf93bdf6e/91298/9echESi.webp 1792w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/9883f29c7216403768967aadf93bdf6e/e92b6/9echESi.png 223w", "/static/9883f29c7216403768967aadf93bdf6e/e66bf/9echESi.png 445w", "/static/9883f29c7216403768967aadf93bdf6e/4ef49/9echESi.png 890w", "/static/9883f29c7216403768967aadf93bdf6e/4e814/9echESi.png 1335w", "/static/9883f29c7216403768967aadf93bdf6e/701e9/9echESi.png 1780w", "/static/9883f29c7216403768967aadf93bdf6e/fa60d/9echESi.png 1792w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
        `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/9883f29c7216403768967aadf93bdf6e/4ef49/9echESi.png",
              "alt": "9echESi",
              "title": "9echESi",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><img parentName="p" {...{
        "src": "/6cda07cbf0af2996ab783c0a318e3533/media-a0h7sAqON67nO-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Sure you don`}{`'`}{`t quite understand how it works and you`}{`'`}{`d struggle to change anything ... but hey who understands their D3 code anyway? Almost no-one.`}</p>
    <p>{`It`}{`'`}{`s like D3 was designed by someone with a PhD in data visualization. (it was)`}</p>
    <h1 {...{
      "id": "3-key-insights-that-help-you-learn-d3js-from-scratch"
    }}>{`3 key insights that help you learn D3.js from scratch`}</h1>
    <p>{`Good news!`}</p>
    <p>{`Turns out D3 ain`}{`'`}{`t so bad. 3 little concepts help you understand any example out there.`}</p>
    <p>{`It`}{`'`}{`s a trick I teach in my workshops. The usual response goes something like `}<em parentName="p">{`"`}{`That`}{`'`}{`s it!? That`}{`'`}{`s what`}{`'`}{`s going on?`}{`"`}</em></p>
    <p>{`Yep. Now I`}{`'`}{`m about to tell you :)`}</p>
    <h2 {...{
      "id": "1-data-manipulation-vs-dom-manipulation"
    }}>{`1) Data manipulation vs. DOM manipulation`}</h2>
    <p>{`All D3 examples are split into two parts:`}</p>
    <ol>
      <li parentName="ol">{`Data manipulation`}</li>
      <li parentName="ol">{`DOM manipulation`}</li>
    </ol>
    <p>{`First you prep your values, then you render.`}</p>
    <p>{`I had to go through many examples to notice what`}{`'`}{`s going on. Inference learning is hard. Most people miss this pattern and it makes D3 look more confusing than it is.`}</p>
    <p>{`The code above is part of a bar chart. Straight from D3`}{`'`}{`s documentation.`}</p>
    <p>{`Here it is again`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/25d2bde8baf1d9e55bed9a13713a2b40/0a47e/static-barchartcode-6fbc274eed4cba9b32493cab9607ff61-d9514.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "106.27802690582959%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'425\\'%20viewBox=\\'0%200%20400%20425\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M88%2054h-2c-1-2-3%200-3%203%201%202%204%203%204%201h-1l-1-1h3l6%202c5%200%206-1%206-2%200-2%200-2%201%200%200%202%201%202%201%201h2c1%202%204%200%204-3s-1-4-3-1h-8c-1-2-3-1-3%201l-1%201v-2l-3-2c-1%200-2%200-2%202M54%20195h-5c-1%202-1%202-3%200H36c-1-3-4%200-4%203s1%204%203%201h2c0%202%201%202%204%200h5l-1-1v-1l3%202c1%201%201%201%201-1s0-2%201-1l2%202h1c1%203%204%200%204-3s-1-4-3-1m0%2047h-2c-2-2-4-1-4%201l-1-1H36c-1-3-4%200-4%203s1%204%203%201h2c0%202%201%202%204%200h5l-1-1v-1l3%202%201-1%201-1%201%202h2c1%203%204%200%204-3s-1-4-3-1m45%20113H82l-2-1c-2%200-2%201-2%204s0%203%202%202l2-2c1-1%201%200%201%201%200%202%201%203%203%200h4l2%201-1-2v-1l2%201c0%202%202%201%202-1%201-2%201-2%201%200l1%202h3c1%202%203%200%203-3s-1-4-4-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/25d2bde8baf1d9e55bed9a13713a2b40/ca0a1/static-barchartcode-6fbc274eed4cba9b32493cab9607ff61-d9514.webp 223w", "/static/25d2bde8baf1d9e55bed9a13713a2b40/75680/static-barchartcode-6fbc274eed4cba9b32493cab9607ff61-d9514.webp 445w", "/static/25d2bde8baf1d9e55bed9a13713a2b40/e88ff/static-barchartcode-6fbc274eed4cba9b32493cab9607ff61-d9514.webp 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "type": "image/webp"
            }}></source>{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/25d2bde8baf1d9e55bed9a13713a2b40/e92b6/static-barchartcode-6fbc274eed4cba9b32493cab9607ff61-d9514.png 223w", "/static/25d2bde8baf1d9e55bed9a13713a2b40/e66bf/static-barchartcode-6fbc274eed4cba9b32493cab9607ff61-d9514.png 445w", "/static/25d2bde8baf1d9e55bed9a13713a2b40/0a47e/static-barchartcode-6fbc274eed4cba9b32493cab9607ff61-d9514.png 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "type": "image/png"
            }}></source>{`
        `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/25d2bde8baf1d9e55bed9a13713a2b40/0a47e/static-barchartcode-6fbc274eed4cba9b32493cab9607ff61-d9514.png",
              "alt": "static barchartcode 6fbc274eed4cba9b32493cab9607ff61 d9514",
              "title": "static barchartcode 6fbc274eed4cba9b32493cab9607ff61 d9514",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Doesn`}{`'`}{`t make a lot of sense does it? How does that 👆 create this 👇`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/9883f29c7216403768967aadf93bdf6e/fa60d/9echESi.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50.672645739910315%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'202\\'%20viewBox=\\'0%200%20400%20202\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M15%206c2%200%202%201%202%205s0%205-2%205v1c2%200%202%201%202%207s0%207-2%208v1c3%200%203%2015%200%2015v1c2%200%203%2014%201%2014v18c2%200%201%2014-1%2014v1c3%200%203%2015%200%2015v1c3%200%203%2015%200%2015v1c2%200%203%2014%201%2014v18c2%200%201%2014-1%2014v1c3%200%203%2015%200%2015v1a5158%205158%200%20003-88V5h-2c-2%200-2%200-1%201m67%2097v97h14V5H82v98m228%2029v68h14V63h-14v69M22%2078l-1%2061v61h14V77h-6l-7%201m212%2066v57h14V87h-14v57m-91%204v52h14V96h-14v52m76%201v51h14V100l-7-1h-7v50m76%204v47h13v-94h-13v47m-167%202v45h14v-90h-14v45m151-43v88h14v-88h-14M67%20170v30h14v-61H67v31m122-27l-1%2029v28h14v-58h-6l-7%201M52%20181v19h14v-38H52v19m273%200v19h14v-38h-14v19m-121%203v16h13v-32h-13v16m151%201v15h14v-31h-14v16m-258%200v15h14v-30H97v15m16%202v13h13v-26h-13v13m273%201v12h14v-25h-14v13m-137%200v12h14v-24h-14v12m-212%203v9h13v-18H37v9m303%200v9h14v-9h-14\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/9883f29c7216403768967aadf93bdf6e/ca0a1/9echESi.webp 223w", "/static/9883f29c7216403768967aadf93bdf6e/75680/9echESi.webp 445w", "/static/9883f29c7216403768967aadf93bdf6e/8d1ba/9echESi.webp 890w", "/static/9883f29c7216403768967aadf93bdf6e/3838e/9echESi.webp 1335w", "/static/9883f29c7216403768967aadf93bdf6e/e11e5/9echESi.webp 1780w", "/static/9883f29c7216403768967aadf93bdf6e/91298/9echESi.webp 1792w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/9883f29c7216403768967aadf93bdf6e/e92b6/9echESi.png 223w", "/static/9883f29c7216403768967aadf93bdf6e/e66bf/9echESi.png 445w", "/static/9883f29c7216403768967aadf93bdf6e/4ef49/9echESi.png 890w", "/static/9883f29c7216403768967aadf93bdf6e/4e814/9echESi.png 1335w", "/static/9883f29c7216403768967aadf93bdf6e/701e9/9echESi.png 1780w", "/static/9883f29c7216403768967aadf93bdf6e/fa60d/9echESi.png 1792w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
        `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/9883f29c7216403768967aadf93bdf6e/4ef49/9echESi.png",
              "alt": "9echESi",
              "title": "9echESi",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Here`}{`'`}{`s how.`}</p>
    <p>{`First you have Data Manipulation.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/676f36db77f490e939c4ab546a062f74/0a47e/static-barchartcode-data-b62f3f758e2a1b37cb436d66a54846d1-d9514.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "106.27802690582959%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'425\\'%20viewBox=\\'0%200%20400%20425\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M54%20195h-2c-2-2-4-1-4%201h-1c-1-2-4-3-4-1h-7c-1-3-4%200-4%203s1%204%203%201c2-1%202-1%202%201h6c3%200%204-1%202-2v-1l3%202c1%201%201%201%201-1v-2l1%202c1%202%201%202%202%201h1c1%202%204%200%204-3s-1-4-3-1m0%2047h-2c-2-2-4-1-4%201h-1c-1-2-4-3-4-1h-7c-1-3-4%200-4%203s1%204%203%201h2c0%202%201%202%203%200h2c2%202%207%201%207-1s0-2%201%200%201%202%202%201h1c1%202%204%200%204-3s-1-4-3-1m5%2028h-5c-1%202-1%202-3%200H41c-2-2-4%200-4%203s0%203%203%202c1-1%202-1%202%201%201%201%201%201%203-1l3-1c1%202%205%201%206-1s1-2%201%200%202%203%202%201h1l2%201c2%200%202-1%202-3%200-4-1-5-3-2m41%2084h-6l-6%201h-6l-2-1c-2%200-2%201-2%204%200%204%201%204%203%201l2-2v2c0%202%201%203%203%201%201-2%202-2%203-1%203%201%204%200%202-1v-1l2%201c0%202%202%201%202-1h1l1%202h3c1%202%203%200%203-3s-1-4-3-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/676f36db77f490e939c4ab546a062f74/ca0a1/static-barchartcode-data-b62f3f758e2a1b37cb436d66a54846d1-d9514.webp 223w", "/static/676f36db77f490e939c4ab546a062f74/75680/static-barchartcode-data-b62f3f758e2a1b37cb436d66a54846d1-d9514.webp 445w", "/static/676f36db77f490e939c4ab546a062f74/e88ff/static-barchartcode-data-b62f3f758e2a1b37cb436d66a54846d1-d9514.webp 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "type": "image/webp"
            }}></source>{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/676f36db77f490e939c4ab546a062f74/e92b6/static-barchartcode-data-b62f3f758e2a1b37cb436d66a54846d1-d9514.png 223w", "/static/676f36db77f490e939c4ab546a062f74/e66bf/static-barchartcode-data-b62f3f758e2a1b37cb436d66a54846d1-d9514.png 445w", "/static/676f36db77f490e939c4ab546a062f74/0a47e/static-barchartcode-data-b62f3f758e2a1b37cb436d66a54846d1-d9514.png 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "type": "image/png"
            }}></source>{`
        `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/676f36db77f490e939c4ab546a062f74/0a47e/static-barchartcode-data-b62f3f758e2a1b37cb436d66a54846d1-d9514.png",
              "alt": "static barchartcode data b62f3f758e2a1b37cb436d66a54846d1 d9514",
              "title": "static barchartcode data b62f3f758e2a1b37cb436d66a54846d1 d9514",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
    <ul>
      <li parentName="ul">{`some sizing variables (margin, width, height)`}</li>
      <li parentName="ul">{`two scales to help with data-to-coordinates conversion (x, y)`}</li>
      <li parentName="ul">{`load the dataset (d3.tsv) and update scale domains`}</li>
      <li parentName="ul">{`use scales to calculate attributes during DOM manipulation`}</li>
    </ul>
    <p>{`And here`}{`'`}{`s the part that paints stuff on your screen`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/95b02f8cf043f94d097e9e7600201649/0a47e/static-barchart-dom-0d48cb4e05c4cbfcf2201b136ba2e6e3-d9514.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "106.27802690582959%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'425\\'%20viewBox=\\'0%200%20400%20425\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M88%2054h-1l-3-1c-2%201-1%205%201%206%202%200%203-1%201-2v-1l2%201%206%202c5%200%206-1%206-2%200-2%200-2%201%200%200%202%201%202%201%201h2c1%202%204%200%204-3s-1-4-4-1h-7l-1-1-2%202-1%201v-2l-3-2c-1%200-2%200-2%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/95b02f8cf043f94d097e9e7600201649/ca0a1/static-barchart-dom-0d48cb4e05c4cbfcf2201b136ba2e6e3-d9514.webp 223w", "/static/95b02f8cf043f94d097e9e7600201649/75680/static-barchart-dom-0d48cb4e05c4cbfcf2201b136ba2e6e3-d9514.webp 445w", "/static/95b02f8cf043f94d097e9e7600201649/e88ff/static-barchart-dom-0d48cb4e05c4cbfcf2201b136ba2e6e3-d9514.webp 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "type": "image/webp"
            }}></source>{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/95b02f8cf043f94d097e9e7600201649/e92b6/static-barchart-dom-0d48cb4e05c4cbfcf2201b136ba2e6e3-d9514.png 223w", "/static/95b02f8cf043f94d097e9e7600201649/e66bf/static-barchart-dom-0d48cb4e05c4cbfcf2201b136ba2e6e3-d9514.png 445w", "/static/95b02f8cf043f94d097e9e7600201649/0a47e/static-barchart-dom-0d48cb4e05c4cbfcf2201b136ba2e6e3-d9514.png 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "type": "image/png"
            }}></source>{`
        `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/95b02f8cf043f94d097e9e7600201649/0a47e/static-barchart-dom-0d48cb4e05c4cbfcf2201b136ba2e6e3-d9514.png",
              "alt": "static barchart dom 0d48cb4e05c4cbfcf2201b136ba2e6e3 d9514",
              "title": "static barchart dom 0d48cb4e05c4cbfcf2201b136ba2e6e3 d9514",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`DOM manipulation in D3 happens via D3 selections. They`}{`'`}{`re a lot like jQuery `}<inlineCode parentName="p">{`$(something)`}</inlineCode>{`. Personally I like to do this part with React.`}</p>
    <p>{`Our example does a few things here`}</p>
    <ul>
      <li parentName="ul">{`selects the `}<inlineCode parentName="li">{`<svg>`}</inlineCode>{` node (d3.select)`}</li>
      <li parentName="ul">{`appends a grouping `}<inlineCode parentName="li">{`<g>`}</inlineCode>{` node (.append) with an SVG positioning attribute (translate)`}</li>
      <li parentName="ul">{`adds a bottom axis by appending a `}<inlineCode parentName="li">{`<g>`}</inlineCode>{`, moving it, then calling `}<inlineCode parentName="li">{`d3.axisBottom`}</inlineCode>{` . D3 has built-in axis generators`}</li>
      <li parentName="ul">{`adds a left axis using the same approach but rotating the ticks`}</li>
      <li parentName="ul">{`appends a text label `}{`"`}{`Frequency`}{`"`}{` to the left axis`}</li>
      <li parentName="ul">{`uses `}<inlineCode parentName="li">{`selectAll.data`}</inlineCode>{` to make a virtual selection of `}<inlineCode parentName="li">{`.bar`}</inlineCode>{` nodes and attach some data, then for every new data value (.enter), appends a `}<inlineCode parentName="li">{`<rect>`}</inlineCode>{` node and gives it attributes`}</li>
    </ul>
    <p>{`That last part is people always get lost. It looks like magic. I published my first D3 book in 2013 and I still think that`}{`'`}{`s magic. 🧙‍♂️`}</p>
    <p>{`It`}{`'`}{`s a declarative approach to rendering data. Works great, hard to understand.`}</p>
    <p>{`You can think of `}<inlineCode parentName="p">{`.enter`}</inlineCode>{` as a loop over your data and everything chained after `}<inlineCode parentName="p">{`.enter`}</inlineCode>{` is your loop`}{`'`}{`s body. Sort of like doing `}<inlineCode parentName="p">{`data.map(d => append(rect).setManyAttributes())`}</inlineCode></p>
    <h2 {...{
      "id": "2-scales"
    }}>{`2) Scales`}</h2>
    <p>{`Scales are D3`}{`'`}{`s most versatile concept. They help you translate between two different spaces. Like, mathematical spaces. I told you this thing was invented by someone with a PhD.`}</p>
    <p>{`Scales work like the mathematical functions you learned about in school. A domain maps to a range using some sort of formula.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "440px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/961aa08a28c91fdc334ef8d1a04c3369/48c0e/wikipedia-commons-thumb-d-df-Function_color_example_3.svg-440px-Function_color_example_3.svg.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "107.62331838565022%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'430\\'%20viewBox=\\'0%200%20400%20430\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M291%2026l4%207v14c2%201%204-3%204-6s1-6%208-13c5-5%205-6%203-6s-4%202-7%206l-4%205-3-5-4-6c-2%200-2%200-1%204M86%2045l3%206%202%205-6%207c-5%205-5%206-3%206s4-2%207-5l4-5%202%205%204%205c2%200%202%200%200-6-4-6-4-7%202-13%204-5%205-6%203-6-1%200-4%202-6%205l-4%204-3-5c-2-4-5-6-5-3m-2%2034c-6%202-11%205-11%206l5-2c7-4%2022-4%2030%200%206%204%2016%2013%2022%2021l4%205c1-1-7-12-13-18-12-11-26-15-37-12m211%2011c-4%202-10%207-10%2010l-1%201-1%202c0%203-1%204-15%204l-14%202h-5l4-7%203-8-5%207-3%208h-8l-99%207c-2%200-3-1-4-4l-3-3%201%204c2%204%202%204-13%204l-16%202c-3%200-3%200-9-10l-7-11-24%2041a514%20514%200%200048%200c1%200-1-4-5-9l-5-9%209-1%2017-1%208-1%204%208c5%2010%205%209%201-1l-3-7h7a8818%208818%200%200199-5l-1%203%202-2c2-4%201-4%2020-5h16v2l1%204v1l1%203c2%201%202%202%201%203-2%204-56%2067-57%2066-1-4%206-39%2012-56%205-16%205-20%200-7-5%2015-11%2040-14%2062%200%206-1%206-17%2025l-17%2020h-21l-4-4-5-4-1-15a282%20282%200%2000-13-63c7%2021%2013%2059%2012%2071v4l-21-18-20-19v-8l-31-1H58v18h62v-3c0-3%201-3%2021%2015%2019%2018%2020%2019%2020%2023v4h-12l-32%201H98l-4-3-4-3-11%2010c-8%207-10%2010-10%2011a1532%201532%200%20019%2031%20246%20246%200%200035-11c2%200-2-3-9-8l-9-6%209-6%209-5-6-4-5-3%2018-1%2035-1h17l5%205%205%205-21%2025v-5c2-15%202-29%201-29l-1%2015c-1%2022%201%2019-27%2051l-23%2027-1-9v-10H89l-20%201v41h41v-19l24-28%2024-27c1%203-5%2030-11%2046-3%2010-2%2011%201%202%204-9%207-23%2010-40l3-13%2011-13%2012-13%2042%2037%204%2015c13%2073%2046%20119%2080%20109%208-3%207-3-1-1-32%208-64-35-77-103l-2-15a826%20826%200%200156%2054c-3%202-3%203%204%204%206%201%207%201%204-5-2-7-2-7-4-4-2%201-2%201-5-1l-55-51-4-37v-15h4l30-1h24v3l2%202%201%201c0%204%207%208%2014%208%2010%200%2016-6%2017-15%201-17-18-25-30-13l-2%205-1%201-1%203c0%203%201%203-30%203l-28%201v-15c2-24-2-18%2033-59%2029-33%2030-35%2032-33l3%201h14l7-5c12-15-2-36-20-30m62%2026l4%2015c11%2032%2014%2058%2014%20102a301%20301%200%2001-10%2097%20368%20368%200%2000-8-214M32%20154a309%20309%200%20007%20174%20312%20312%200%2001-7-174m261%200c-10%205-12%2018-4%2027%2011%2011%2029%203%2029-13%200-12-14-20-25-14M60%20185v6h58v-13H60v7m151%2029l-15%2017h29v-17l1-17-15%2017m-21%2024l-5%206%2021%2019%2021%2019-1-13-1-24v-12h-31l-4%205m102%2035c-15%2010-9%2033%209%2033%2014%200%2022-13%2016-26-4-8-17-12-25-7m-164%2088c-16%2023-37%2029-55%2016-6-4-8-3-2%201%2019%2014%2044%206%2060-18%206-9%204-8-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/961aa08a28c91fdc334ef8d1a04c3369/ca0a1/wikipedia-commons-thumb-d-df-Function_color_example_3.svg-440px-Function_color_example_3.svg.webp 223w", "/static/961aa08a28c91fdc334ef8d1a04c3369/23a50/wikipedia-commons-thumb-d-df-Function_color_example_3.svg-440px-Function_color_example_3.svg.webp 440w"],
              "sizes": "(max-width: 440px) 100vw, 440px",
              "type": "image/webp"
            }}></source>{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/961aa08a28c91fdc334ef8d1a04c3369/e92b6/wikipedia-commons-thumb-d-df-Function_color_example_3.svg-440px-Function_color_example_3.svg.png 223w", "/static/961aa08a28c91fdc334ef8d1a04c3369/48c0e/wikipedia-commons-thumb-d-df-Function_color_example_3.svg-440px-Function_color_example_3.svg.png 440w"],
              "sizes": "(max-width: 440px) 100vw, 440px",
              "type": "image/png"
            }}></source>{`
        `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/961aa08a28c91fdc334ef8d1a04c3369/48c0e/wikipedia-commons-thumb-d-df-Function_color_example_3.svg-440px-Function_color_example_3.svg.png",
              "alt": "wikipedia commons thumb d df Function color example 3 svg 440px Function color example 3 svg",
              "title": "wikipedia commons thumb d df Function color example 3 svg 440px Function color example 3 svg",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Colored shapes in the domain map to colors in the range. No formula for this one, which makes it an ordinal scale.`}</p>
    <pre><code parentName="pre" {...{}}>{`<code>let shapes = d3.scaleOrdinal()
    .domain(['triangle', 'rectangle', ...)
    .range(['red', 'orange', ...)
</code>
`}</code></pre>
    <p>{`Once you have this scale, you can use it to translate from shapes to colors. `}<inlineCode parentName="p">{`shapes('triangle')`}</inlineCode>{` returns `}<inlineCode parentName="p">{`'red'`}</inlineCode>{`, rectangle is orange, etc..`}</p>
    <p>{`You can create many different types of scales.`}</p>
    <p>{`Linear, logarithmic, quantize, etc. Any basic transformation you can think of exists. The rest you can create by writing custom scales.`}</p>
    <p>{`You`}{`'`}{`re most often going to use scales to turn data values into coordinates.`}</p>
    <h2 {...{
      "id": "3-d3-layouts"
    }}>{`3) D3 layouts`}</h2>
    <p>{`Sure `}<inlineCode parentName="p">{`.enter.append`}</inlineCode>{` looks like magic, but D3 layouts are the real mind=blown in the D3 ecosystem. They take your input data and return a full-featured visualization.`}</p>
    <p>{`For example, a force layout using forces between nodes to place them on the screen.`}</p>
    <p><img parentName="p" {...{
        "src": "/0d8834a80540027046350cd150e1af61/Dwk9P9c.gif",
        "alt": null
      }}></img></p>
    <p>{`I don`}{`'`}{`t know how that works and that`}{`'`}{`s the point. You don`}{`'`}{`t have to. The layout does it for you.`}</p>
    <p>{`Here`}{`'`}{`s a key insight about layouts: `}<em parentName="p">{`Layouts are the data part.`}</em></p>
    <p>{`You take a `}<inlineCode parentName="p">{`forceLayout`}</inlineCode>{` and feed it your data. It returns an object with a `}<inlineCode parentName="p">{`tick`}</inlineCode>{` event callback.`}</p>
    <pre><code parentName="pre" {...{}}>{`var simulation = d3.forceSimulation()
    .force("link", d3.forceLink().id(function(d) { return d.id; }))
    .force("charge", d3.forceManyBody())
    .force("center", d3.forceCenter(width / 2, height / 2));
`}</code></pre>
    <p>{`This `}<inlineCode parentName="p">{`simulation`}</inlineCode>{` now handles everything about rendering nodes. Changes their positions on every tick callback.`}</p>
    <p>{`But it is up to you to render them.`}</p>
    <p>{`A layout handles your data visualization in the abstract. You`}{`'`}{`re still in control of rendering. For a force layout, you have to update the DOM on every tick of the animation.`}</p>
    <p>{`Once I figured this out, all fancy visualizations out there started making sense.`}</p>
    <p><img parentName="p" {...{
        "src": "/c788c28feb2564095f8dcc98f120437b/media-65HMb0y6hAxiyezDbC-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`What`}{`'`}{`s something surprising you learned recently? Have you tried D3? tweet me`}</p>
    <p>{`Cheers, ~Swizec`}</p>
    <p>{`PS: you can watch me explain all this in `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=_kgyCiWbcY8"
      }}>{`a 5 min video`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      